import React from 'react';
import classnames from 'classnames';
import styles from './inline-status.css';
import { WarningIcon, CheckmarkIcon, ErrorIcon } from '../icons/icons';
import { Icon } from '../icon';
import Colors from '../colors';

interface InlineStatusProps {
  /** Message to show on the status */
  children: string;
  /** Provides visual elements to identify the status as a warning, success or error message */
  type: 'success' | 'warning' | 'error';
  /** Adds additional classes to the component. */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * InlineStatus Component
 *
 * @param {InlineStatusProps} param
 *
 * @returns JSX.ELEMENT
 */
export const InlineStatus = ({
  children,
  type,
  className,
  'data-testid': dataTestId
}: InlineStatusProps) => {
  const statusClasses = classnames(styles.status, className, {
    [styles[type]]: true
  });
  const icons = {
    error: (
      <Icon color={Colors.Amaranth}>
        <ErrorIcon />
      </Icon>
    ),
    success: (
      <Icon color={Colors.Shamrock}>
        <CheckmarkIcon />
      </Icon>
    ),
    warning: (
      <Icon color={Colors.Orange}>
        <WarningIcon />
      </Icon>
    )
  };

  return (
    <div className={statusClasses} data-testid={dataTestId}>
      {icons[type]}
      <div className={styles.label}>{children}</div>
    </div>
  );
};

export default InlineStatus;
